import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CognitoAuth } from "../Utils/cognito-auth";  // Import CognitoAuth function
import { useAuth } from "../Utils/AuthContext"; // Import useAuth to get user info
import { Navbar, Nav } from 'react-bootstrap';
import './Header.css';

function Header() {
  const [expanded, setExpanded] = useState(false);
  const { name, email } = useAuth();  // Using context to get user info
  const navigate = useNavigate();

  // Determine if the user is authenticated
  const isAuthenticated = name && email;

  // UseEffect for expanding/collapsing the navbar
  useEffect(() => {
    if (expanded) {
      const timer = setTimeout(() => setExpanded(false), 7000); // Collapse after 7 seconds of idle
      return () => clearTimeout(timer);  // Cleanup timer on unmount or when expanded changes
    }
  }, [expanded]);

  // Initialize CognitoAuth with true, true, true as per your requirement
  const { signOut } = CognitoAuth(true, true, true);  // Ensure CognitoAuth is initialized correctly

  // Function to handle user log out
  const handleLogout = async () => {
    await signOut();  // Call the signOut function from CognitoAuth
    window.location.reload();
    navigate("/");  // Redirect to home page after logout
  };

  return (
    <>
      <div className="header">
        <Navbar expanded={expanded} onToggle={() => setExpanded(!expanded)} expand="lg">
          <Navbar.Brand as={Link} to="/" className="mx-auto">
            <img className="logo" src="/images/logo.png" alt="Teens Money" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarNav" />
          <Navbar.Collapse id="navbarNav" className='justify-content-center'>
            <Nav>
              <Nav.Link as={Link} to="/budgetbuddy" onClick={() => setExpanded(false)}>
                Budget Buddy
              </Nav.Link>
              <Nav.Link as={Link} to="/stockmarketgame" onClick={() => setExpanded(false)}>
                Stock Market Game
              </Nav.Link>
              <Nav.Link as={Link} to="/financle" onClick={() => setExpanded(false)}>
                Financle
              </Nav.Link>
              <Nav.Link as={Link} to="/forum" onClick={() => setExpanded(false)}>
                Forum
              </Nav.Link>
              {isAuthenticated ? (
                <Nav.Link as={Link} onClick={handleLogout}>
                  Log Out
                </Nav.Link>
              ) : (
                <Nav.Link as={Link} to="/login" onClick={() => setExpanded(false)}>
                  Log In
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
      <div className="border-below"></div>
    </>
  );
}

export default Header;
